<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <!-- Begin:Invoice No -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">Invoice No :</label>
                <input
                  id="oruInvoiceNo"
                  name="oruInvoiceNo"
                  v-model="oruInvoiceNo"
                  type="text"
                  maxlength="450"
                  class="form-control"
                  placeholder="Invoice No."
                />
                <span class="form-text"></span>
              </div>
            </div>
            <!-- End:Invoice No -->

            <!-- Begin:งบประมาณ input -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">Invoice Date :</label>
                <div class="input-group date">
                  <input
                    type="text"
                    class="form-control"
                    id="oruInvoiceDate"
                    name="oruInvoiceDate"
                    ref="oruInvoiceDate"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">
                      <i class="la la-calendar-check-o"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- End:งบประมาณ input -->

            <!-- Begin:Vandor select2 -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">Supplier :</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'oruSupplier'"
                  :name="'oruSupplier'"
                  :select2-options="oruSupplierOptions"
                  v-model="oruSupplier"
                  ref="oruSupplierSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
            <!-- End:ประเภทงบประมาณ select2 -->
          </div>
          <!-- Begin:Picture element -->
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <label>แนบไฟล์:</label>
                <div v-show="oruDownloadUrl != null">
                  <span class="form-control-plaintext">{{ oruFileName }}</span>
                  <a :href="oruDownloadUrl" target="_blank">Download</a>
                  <br />
                  <br />
                </div>
                <button
                  type="button"
                  class="btn m-btn--pill btn-info btn-block uploader-btn col-xl-2"
                  id="uploader-order"
                  :data-ref="uuid"
                >
                  <i class="flaticon-upload-1"></i>ไฟล์
                </button>
                <div class="row" id="container-file"></div>
              </div>
            </div>
          </div>
          <!-- End:Picture element -->

          <div class="kt-section kt-section--first">
            <h3 class="kt-section__title">รายการสินค้า/ทรัพย์สิน:</h3>
            <div class="kt-section__body">
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table
                    class="table table-sm table-striped table-bordered table-hover table-checkable"
                    style="min-width: 1440px;"
                  >
                    <thead>
                      <tr>
                        <th class="text-center" width="5%">ลำดับ</th>
                        <th class="text-center" width="15%">รหัส/ชื่อสินค้า</th>
                        <th class="text-center" width="15%">จำนวน</th>
                        <th class="text-center" width="15%">ราคา</th>
                        <th class="text-center" width="15%">รวม</th>
                        <th class="text-center" width="15%">งบประมาณ</th>
                        <th class="text-center" width="15%">โควต้า</th>
                        <th class="text-center" width="5%">คำสั่ง</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="oruItems == null || oruItems.length == 0">
                        <td colspan="9" class="text-muted text-center">
                          คลิก + เพื่อเพิ่มรายการใหม่
                        </td>
                      </tr>
                      <template v-for="(item, i) in oruItems">
                        <order-item-row
                          ref="orderItems"
                          :key="i"
                          :rowIndex="i"
                          :item="item"
                          @removeItem="onRemoveItemClick"
                        ></order-item-row>
                      </template>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="9">
                          <button
                            type="button"
                            class="btn btn-sm btn-brand"
                            @click.prevent="onAddItemClick"
                          >
                            <i class="fa fa-plus"></i> เพิ่มรายการใหม่
                          </button>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl-12">
            <label class="kt-button">
              <!-- <button type="button" class="btn btn-default" id="addProduct" @click="addProduct">
                <i class="fas fa-plus"></i> เพิ่มรายการ
              </button>-->
            </label>
          </div>
        </div>
      </div>

      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
        <button type="submit" class="btn btn-primary" data-dismiss="modal">
          <i class="la la-save"></i> บันทึกข้อมูล
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import datepicker from "../../../Shared/Datepicker";
import select2 from "../../../Shared/Select2";
import orderItemRow from "./OrderItemRow";
import plupload from "plupload";

export default {
  components: {
    select2,
    datepicker,
    orderItemRow,
  },
  data() {
    var self = this;
    return {
      uuid: null,
      oruItems: [],
      i: 0,
      oruStockHeaderId: null,
      oruInvoiceNo: null,
      oruInvoiceDate: null,
      oruSupplier: null,
      oruSummary: 0,
      attachedId: null,
      oruFileName: null,
      oruDownloadUrl: null,
      oruSupplierOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Vendors/Select2Vendor",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    onAddItemClick(e) {
      this.oruItems.push({
        odcMaterialCode: null,
        odcQuantity: 0,
        odcPrice: 0,
        odcTotal: null,
        odcBudgetId: null,
        odcQuotaId: null,
      });
    },
    onRemoveItemClick(index, delItem) {
      this.oruItems.splice(index, 1);
      for (let i = 0; i < this.oruItems.length; i++) {}
    },
    initPlUploader() {
      let self = this;
      self.uuid = this._uid;

      var uploader = new plupload.Uploader({
        runtimes: "html5,flash,silverlight,html4",
        multi_selection: false,
        // multipart: false,
        browse_button: "uploader-order", // you can pass in id...
        // container: document.getElementById("uploader-agent"), // ... or DOM Element itself
        url: "/Components/Plupload?reference=" + self.uuid, // คือ Url มาตรฐานของ plupload

        chunk_size: "1mb",
        max_retries: 5,
        filters: {
          max_file_size: "10mb",
          mime_types: [
            {
              title: "doc files",
              extensions: "jpg,jpeg,png,JPG,JPEG,PNG,pdf,PDF,xlsx,xls,doc,docx",
            },
          ],
        },
        resize: {
          width: 300,
          quality: 100,
        },
        init: {
          FilesAdded: function(up, files) {
            var $imageContainer = $("#container-file");
            if ($("#files", $imageContainer).data("file-id") != null) {
              $imageContainer.empty();
            }
            plupload.each(files, function(file) {
              self.odcFilename = file.name;
              if (
                $('div[data-file-name="' + file.name + '"]', $imageContainer)
                  .length == 0
              ) {
                var nativeData = file.getNative();

                if (files[0]) {
                  self.odcFileChk = true;
                  self.FileUpload = {
                    isNew: true,
                    fileDataContext: nativeData,
                    fileId: file.id,
                    fileName: file.name,
                  };
                }

                if (typeof FileReader != "undefined") {
                  var image_holder = $(
                    '<div class="col-md-4 m--margin-top-20 loader loader-secondary bg-overlay img-wrap" id="' +
                      file.id +
                      '"></div>'
                  );
                  $(
                    '<div style="display:none" id="files" data-file-id="' +
                      file.id +
                      '" data-file-name="' +
                      file.name +
                      '" data-file-uploaded="false" alt="' +
                      file.name +
                      '">' +
                      file.name +
                      '<div id="myProgress" class=" progress' +
                      file.id +
                      '"><div id="myBar' +
                      '" class="progress-bar bg-success"><b></b></div ></div></div>'
                  ).appendTo(image_holder);
                  image_holder.appendTo($imageContainer);
                  var reader = new FileReader();
                  reader.onload = function(e) {
                    $("div[data-file-id=" + file.id + "]")
                      .attr("src", e.target.result)
                      .show();
                  };
                  reader.readAsDataURL(nativeData);
                }
              }
            });
            up.start();
          },

          UploadProgress: function(up, file) {
            document
              .getElementById(file.id)
              .getElementsByTagName("b")[0].innerHTML =
              "<span>" + file.percent + "%</span>";
            document.getElementById("myBar").style.width =
              file.percent - 1 + "%";
          },
        },
      });
      uploader.init();
    },
    async formSubmit(e) {
      let router = this.$router;
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      //Validate Item not null
      if (self.oruItems.length == 0) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "กรุณาเพิ่มรายการสินค้า/ทรัพย์สิน",
          "warning"
        );
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      var sItems = [];
      self.oruItems.forEach((element) => {
        sItems.push({
          MATERIALCODE: element.odcMaterialCode,
          Price: element.odcPrice,
          QTY: element.odcQuantity,
          Summary: element.oruSummary,
          BudgetId: element.odcBudgetId,
          QuotaId: element.odcQuotaId,
          Summary: element.odcTotal,
        });
      });

      let uploadedFile = null;

      if ( this.FileUpload && this.FileUpload.isNew && this.FileUpload.fileDataContext ) {
        try {
          const file = this.FileUpload;
          const formData = new FormData();
          formData.append("File", file.fileDataContext);
          formData.append("FolderName", "StockOrder");

          const uploadResponse = await axios.post("/Api/File/FileUpload", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });

          uploadedFile = {
            contentType: file.fileDataContext.type || "-",
            downloadUrl: uploadResponse.data.fileUrl,
            fileInfoId: uploadResponse.data.fileInfoId,
            fileName: file.fileName,
            gridFsId: uploadResponse.data.gridFsId,
            sysName: "-",
          };
        } catch (error) {
          console.error("เกิดข้อผิดพลาดในการอัปโหลดไฟล์:", error);
        }
      }

      axios({
        method: "put",
        url: "/Api/Stock",
        data: {
          stockHeaderId: self.oruStockHeaderId,
          invoiceNo: self.oruInvoiceNo,
          invoiceDate: self.oruInvoiceDate.format("DD/MM/YYYY"),
          vendorId: self.oruSupplier,
          attachedId: self.attachedId,
          fileUpload: uploadedFile,
          stockItems: sItems,
        },
      })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.oruInvoiceDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    self.oruInvoiceDate = moment();
    $(self.$refs.oruInvoiceDate)
      .datepicker("update", self.oruInvoiceDate.format("DD/MM/YYYY"))
      .on("changeDate", function(e) {
        self.oruInvoiceDate = moment(e.date);
      });

    self.initPlUploader();

    $(this.$refs.form).validate({
      rules: {
        oruInvoiceNo: "required",
        oruInvoiceDate: "required",
        oruSupplier: "required",
      },
      messages: {
        oruInvoiceNo: "กรุณาระบุ InvoiceNo",
        oruInvoiceDate: "กรุณาระบุ InvoiceDate",
        oruSupplier: "กรุณาระบุ Supplier",
      },
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";

    axios
      .get("/Api/Stock/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          if (response.data != null && response.data.length > 0) {
            self.oruStockHeaderId = response.data[0].stockHeaderId;
            self.oruInvoiceNo = response.data[0].invoiceNo;
            self.attachedId = response.data[0].attachedId;
            self.oruFileName = response.data[0].fileName;
            if (response.data[0].downloadUrl) {
              self.oruDownloadUrl =
                `/Api/File/FileDownloadByte?FileInfoId=${response.data[0].downloadUrl}&ContentType=${encodeURIComponent(response.data[0].contentType)}&FileName=${encodeURIComponent(response.data[0].fileName)}`;
            }
            self.oruInvoiceDate = moment(
              response.data[0].invoiceDateFormat,
              "DD/MM/YYYY"
            );
            $(self.$refs.oruInvoiceDate).datepicker(
              "update",
              response.data[0].invoiceDateFormat2
            );

            if (response.data[0].vendorId) {
              self.$refs.oruSupplierSelect2.setSelectedData({
                id: response.data[0].vendorId,
                text: response.data[0].vendorName,
              });
            }

            for (let i = 0; i < response.data.length; i++) {
              var item = response.data[i];
              self.oruItems.push({
                odcMaterialCode: item.materialCode,
                odcQuantity: item.qty,
                odcPrice: item.price,
                odcTotal: item.summaryItem,
                odcBudgetId: item.budgetId,
                odcQuotaId: item.quotaId,
                selectedMaterialCodeData: {
                  id: item.materialCode,
                  text: item.materialName + " [" + item.materialCode + "]",
                  data: null,
                },
                selectedBudgetData: {
                  id: item.budgetId,
                  text: item.budgetName,
                  data: null,
                },
                selectedQuotaData: {
                  id: item.quotaId,
                  text: item.quotaName,
                  data: null,
                },
              });

              setTimeout(function() {
                self.$refs.orderItems[i].$refs.odcMaterialCode.setSelectedData(
                  self.oruItems[i].selectedMaterialCodeData
                );

                self.$refs.orderItems[i].$refs.odcBudgetId.setSelectedData(
                  self.oruItems[i].selectedBudgetData
                );

                self.$refs.orderItems[i].$refs.odcQuotaId.setSelectedData(
                  self.oruItems[i].selectedQuotaData
                );
              }, 100);
            }
          }
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูลการสั่งซื้อที่คุณเลือก",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการสั่งซื้อได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
  },
};
</script>



// WEBPACK FOOTER //
// App/Components/Master/Order/OrderUpdate.vue